export default {
  module: {
    name: 'hamcq-auth-wechat',
    id: 'WeChatAuth',
    icon: 'fab fa-weixin'
  },
  package: {
    name: 'flarum-ext-auth-wechat'
  },
  api: {
    uri: '/auth/wechat'
  }
};
